import { render } from "./agent.leads.preview.vue?vue&type=template&id=1a10a5c6"
import script from "./agent.leads.preview.vue?vue&type=script&lang=js"
export * from "./agent.leads.preview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__